<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header-v2'
import Layout from '@/router/layouts/main.vue'
import { required } from 'vuelidate/lib/validators'
import { Helper } from '@/mixin/helper'
import {
  GET_COMPANY_IDLE_PARK_TIME,
  UPDATE_COMPANY_IDLE_PARK_TIME,
} from '@/services/api/setting/liveview/company'
import McButton from '@/components/McButton'

export default {
  page: {
    title: 'Setting',
    meta: [
      {
        name: 'description',
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    McButton,
  },
  mixins: [Helper],
  apollo: {
    company: {
      query: GET_COMPANY_IDLE_PARK_TIME,
      fetchPolicy: 'no-cache',
      variables() {
        return {
          filter: {
            id: Number(this.getCompanyId()),
          },
        }
      },
      result({ data }) {
        if (data.company.isSuccessful) {
          this.idleTime = data.company.company.idleTimeout
          this.parkTime = data.company.company.parkTimeout
        }
      },
    },
  },
  data() {
    return {
      title: 'Live View',
      isSubmitted: false,
      idleTime: null,
      parkTime: null,
    }
  },
  validations: {
    idleTime: { required },
    parkTime: {
      required,
      greaterThanIdle: function () {
        return this.parkTime >= this.idleTime
      },
    },
  },
  computed: {
    idleTimeClass() {
      if (this.$v.idleTime.$error) return 'mc-form-input is-invalid'
      else return 'mc-form-input'
    },
    parkTimeClass() {
      if (this.$v.parkTime.$error) return 'mc-form-input is-invalid'
      else return 'mc-form-input'
    },
    subTitle() {
      return this.$t('setting.list.liveView.description')
    },
    breadcrumbItems() {
      return [
        {
          text: this.$t('setting.homePage.pengaturan'),
          to: '/setting',
        },
        {
          text: 'Live View',
        },
      ]
    },
  },
  methods: {
    toSave() {
      this.isSubmitted = true
      this.$v.$touch()
      if (this.$v.idleTime.$error || this.$v.parkTime.$error) this.isSubmitted = false
      else {
        this.$apollo
          .mutate({
            mutation: UPDATE_COMPANY_IDLE_PARK_TIME,
            variables: {
              input: {
                id: Number(this.getCompanyId()),
                idleTimeout: Number(this.idleTime),
                parkTimeout: Number(this.parkTime),
              },
            },
          })
          .then((res) => {
            if (res.data.updateCompany.isSuccessful) this.$mcToast.success(this.$t('global.alert.text.saved'))
            else this.$mcToast.warning(res.data.updateCompany.message)
          })
          .catch((err) => {
            // eslint-disable-next-line no-console
            console.log(err)
          })
          .finally(() => (this.isSubmitted = false))
      }
    },
  },
}
</script>

<template>
  <Layout>
    <PageHeader
      :title="title"
      :subTitle="subTitle"
      :items="breadcrumbItems"
      hasBreadcrumb
      hasBackButton
    >
      <template #afterTitle>
        <McButton icon="icon-outline_save" :text="$t('global.save')" @click.prevent="toSave" />
      </template>
    </PageHeader>

    <h4 class="card-title position-relative">
      {{ $t('setting.list.liveView.intervalStatus') }}
      <span
        v-b-tooltip.click.leftbottom="
          'Waktu interval digunakan untuk menentukan durasi perubahan status diam dan parkir.'
        "
        class="mc-input-info__btn"
      >
        <i class="bx bx-info-circle"></i>
      </span>
    </h4>

    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-6">
            <span class="mc-card__subtitle-setliveview">
              {{ $t('setting.list.liveView.intervalIdle') }}<i class="text-danger">*</i>
            </span>
            <b-input-group
              id="idleTime-label"
              class="mt-2"
              label="Interval Waktu Diam"
              label-for="idleTime"
            >
              <b-form-input v-model="idleTime" :class="idleTimeClass" type="number" min="1" />
              <b-input-group-append>
                <div class="mc-input-group-append">
                  <span class="append-text">{{ $t('global.time.minutes') }}</span>
                </div>
              </b-input-group-append>
              <div v-if="$v.idleTime.$error" class="invalid-feedback">
                <span>{{ $t('setting.list.liveView.intervalRequired') }}</span>
              </div>
            </b-input-group>
          </div>
          <div class="col-6">
            <span class="mc-card__subtitle-setliveview">
              {{ $t('setting.list.liveView.intervalPark') }}<i class="text-danger">* </i>
            </span>
            <b-input-group
              id="parkTime-label"
              class="mt-2"
              label="Interval Waktu Parkir"
              label-for="parkTime"
            >
              <b-form-input v-model="parkTime" :class="parkTimeClass" type="number" min="0" />
              <b-input-group-append>
                <div class="mc-input-group-append">
                  <span class="append-text">{{ $t('global.time.minutes') }}</span>
                </div>
              </b-input-group-append>
              <div v-if="$v.parkTime.$error" class="invalid-feedback">
                <span v-if="!$v.parkTime.required">
                  {{ $t('setting.list.liveView.intervalRequired') }}
                </span>
                <span v-else-if="!$v.parkTime.greaterThanIdle">
                  {{ $t('setting.list.liveView.intervalLimit') }}
                </span>
              </div>
            </b-input-group>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
